module.exports = __webpack_public_path__ + "img/audit-access.88fe5ad5.svg";